import LinkIcon from "@/common/images/icons/link.svg?react";
import EmbedIcon from "@/common/images/icons/embed.svg?react";
import RedditIcon from "@/common/images/icons/reddit_desktop.svg?react";
import TwitterIcon from "@/common/images/icons/twitter.svg?react";
import DiscordIcon from "@/common/images/icons/discord_desktop.svg?react";
import StackIcon from "@/common/images/icons/stack.svg?react";

export const getShareMenuItems = (onShareClick: (label: string) => void, isGifPublished: boolean, userIsAuthenticated: boolean) => {
  return [
    {
      groupName: null,
      groupMobileName: null,
      items: [
        {
          icon: LinkIcon,
          title: "Copy Link",
          onClick: () => onShareClick("Copy Link")
        },
        {
          icon: EmbedIcon,
          title: "Embed",
          onClick: () => onShareClick("Embed")
        },
        ...(userIsAuthenticated ? [{
          icon: StackIcon,
          title: "Add to Niche",
          disabled: !isGifPublished,
          onClick: () => onShareClick("Add to Niche")
        }] : [])
      ]
    },
    {
      groupName: "Social Share",
      groupMobileName: "Social Share",
      items: [
        {
          icon: RedditIcon,
          title: "Reddit",
          onClick: () => onShareClick("Reddit")
        },
        {
          icon: TwitterIcon,
          title: "X",
          onClick: () => onShareClick("Twitter")
        },
        {
          icon: DiscordIcon,
          title: "Discord",
          onClick: () => onShareClick("Discord")
        }
      ]
    }
  ];
};
